import {
  GetIdTokenClaimsOptions,
  IdToken,
  LogoutOptions,
  useAuth0,
  User,
} from "@auth0/auth0-react";
import { createContext, FC, ReactNode, useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { useHistory } from "react-router-dom";
import auth from "services/auth";

import AuthAuthorize from "views/Settigns/AuthView";
import { appConfig } from "env-config";
import NotAuthorized from "views/NotAuthorize";
import authSupplier from "services/Supplier/authSupplier";
import LoadingOverlay from "views/Settigns/LoadingOverlay";

export interface IUserAuth0Context {
  user: User | undefined;
  userRole: string;
  setLogout?: (state: boolean) => void;
  logout: (options?: LogoutOptions | undefined) => void;
  getIdTokenClaims: (
    options?: GetIdTokenClaimsOptions
  ) => Promise<IdToken | undefined>;
}

export interface TokenProps {
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  nbf: number;
  canReviewStatusChange: string;
  role: string;
  email?: string;
  sub: string;
  user?: string;
  // eslint-disable-next-line camelcase
  unique_name: string;
  idPerfil: number | string;
}

interface Auth0ProviderProps {
  children: ReactNode;
}

export const UserAuth0Provider = ({ children }: Auth0ProviderProps) => {
  const navigate = useHistory();
  const [firstRender, setFirstRender] = useState(true);
  const [loading, setLoading] = useState(true);
  const [logoutState, setLogout] = useState(false);
  const [count, setCount] = useState(0);
  const [notAuthorize, setNotAuthorize] = useState(false);
  const [accessGranted, setAccessGranted] = useState(true);

  // const { setLoading } = useAuth()
  const domain = appConfig.REACT_APP_AUTH0_DOMAIN;
  const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
  const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;

  const [userRole] = useState("");

  const {
    user,
    logout,
    getIdTokenClaims,
    isAuthenticated,
    getAccessTokenSilently,
  } = useAuth0();

  const getRoles = async () => {
    setLoading(true);
    const userInfos = JSON.parse(
      localStorage.getItem(
        `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
      )
    );

    const decodedToken = decodeToken(
      userInfos?.body?.access_token
    ) as TokenProps;

    setCount(count + 1);
    if (user && firstRender) {
      if (decodedToken === null) {
        setAccessGranted(false);
      }
      user.sub.split("|")[0] !== "waad"
        ? await authSupplier
            .getUserPopulateData()
            .then(() => {
              setAccessGranted(true);
              if (decodedToken?.role === undefined) {
                logout({ returnTo: window.location.origin });
                // window.location.reload();
              } else {
                setLoading(false);
                setFirstRender(false);
              }
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) {
                setFirstRender(true);
              } else if (error.response && error.response.status === 404) {
                setNotAuthorize(true);
              } else {
                setLoading(false);
                setFirstRender(false);
                // navigate.push('/not-authorized')

                // handle other errors
              }
              setAccessGranted(true);

              // navigate.push('/not-authorized')
            })
        : await auth
            .getUserPopulateData()
            .then(() => {
              setAccessGranted(true);

              if (decodedToken?.role === undefined) {
                logout({ returnTo: window.location.origin });

                // window.location.reload();
              } else {
                setLoading(false);
                setFirstRender(false);
              }
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) {
                setFirstRender(true);
              } else if (error.response && error.response.status === 404) {
                setNotAuthorize(true);
              } else {
                setLoading(false);
                setFirstRender(false);
                // navigate.push('/not-authorized')

                // handle other errors
              }
              setAccessGranted(true);

              // navigate.push('/not-authorized')
            });
    }
    if (!decodedToken && firstRender) {
      setLoading(false);
      setAccessGranted(true);
    }
    if (decodedToken && !firstRender) {
      setLoading(false);
      setAccessGranted(true);
    }
    if (!decodedToken && !isAuthenticated && !firstRender) {
      setLoading(false);
      setAccessGranted(true);
    }
  };

  useEffect(() => {
    getRoles();
  }, [user]);

  return (
    <UserAuth0Context.Provider
      value={{
        user,
        userRole,
        setLogout,
        logout,
        getIdTokenClaims,
      }}
    >
      {notAuthorize ? (
        <NotAuthorized />
      ) : loading || !isAuthenticated || !accessGranted ? (
        <AuthAuthorize />
      ) : (
        children
      )}
    </UserAuth0Context.Provider>
  );
};
export default UserAuth0Provider;
export const UserAuth0Context = createContext<IUserAuth0Context>(
  {} as IUserAuth0Context
);
